export default "__VITE_ASSET__BxnTZSFF__"